import { useState } from 'react';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Container } from 'ui/container/Container';
import { SegmentedControl } from 'ui/segmentedControl/SegmentedControl';
import { Divider } from 'ui/divider/Divider';
import { RelativeTime } from 'ui/utility/relativeTime';
import { ContentRestoreButton } from '../ContentRestoreButton';
import { StyledDL } from '../ContentPreview.styled';
import { VIEW_OPTIONS } from './constants';
import { AppleWrapper } from './AppleWrapper';
import { AndroidWrapper } from './AndroidWrapper';
import { ContentPreviewContainer, DevicePreview } from './ContentPreviewSms.styled';

import type { TemplateDiffContentPreviewProps, TemplateDiffContentSMS } from '../../../types';

type ContentPreviewSmsProps = TemplateDiffContentSMS & TemplateDiffContentPreviewProps;

export const ContentPreviewSms = ({ onClick, templateId, ...content }: ContentPreviewSmsProps) => {
  const [previewViewOption, setPreviewViewOption] = useState<'apple' | 'android'>('apple');
  return (
    <Container size="medium" variant="primary" shadow="small">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <StyledDL>
            <dt>Created</dt>
            <dd>
              <RelativeTime timestamp={content.createdAt} />
            </dd>
            <dt>Created by</dt>
            <dd>{content.creatorUserId}</dd>
          </StyledDL>
          <ContentRestoreButton contentId={content.id} onClick={() => onClick(content)} />
        </FlexSpacer>
        <Container size="small" hasBorder>
          <ContentPreviewContainer>
            <DevicePreview
              data-test="template-diff-sms-preview-device"
              data-platform={previewViewOption}
            >
              {previewViewOption === 'apple' ? (
                <AppleWrapper>
                  <div>{content.message}</div>
                </AppleWrapper>
              ) : (
                <AndroidWrapper>
                  <div>{content.message}</div>
                </AndroidWrapper>
              )}
            </DevicePreview>
          </ContentPreviewContainer>
        </Container>
        <Divider />
        <FlexSpacer justifyContent="flex-start">
          <SegmentedControl
            data-test="template-diff-sms-segmented-control"
            onSelect={setPreviewViewOption}
            options={VIEW_OPTIONS}
            value={previewViewOption}
          />
        </FlexSpacer>
      </FlexSpacer>
    </Container>
  );
};
